import React, { useEffect, useState } from "react";
import DataTable from "../../../components/AdminTable//DataTable";
import { Link } from "react-router-dom";
import Select from "react-select";
import { apiKey } from "../../../config/config";
import axios from "axios";
import { languageHelper } from "../../../config/helperFunctions";

function Inventory() {
  
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN"),
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Ingredient(Code)"),
      cell: (row) => `${row.row.original.name}(${row.row.original.code || ""})`,
    },
    {
      header: languageHelper("Category"),
      cell: (row) => row.row.original?.ingredient_category?.category_name,
    },
    {
      header: languageHelper("Stock Qty/Amount"),
      cell: (row) =>
        `${row.row.original?.stock_value?.toFixed(2)} ${
          row.row.original?.ingredient_unit?.unit_name || ""
        }`,
    },
    {
      header: languageHelper("Alert Qty/Amount"),
      cell: (row) =>
        `${row.row.original?.alert_quantity} ${
          row.row.original?.ingredient_unit?.unit_name || ""
        }`,
    },
  ];
  const [data, setData] = useState([]);
  const [totalStockValue, setTotalStockValue] = useState(0);
  const [buttonDataa] = useState([
    {
      buttonText: languageHelper("Ingredient in Alert"),
      path: "ingredientsAlert",
    },
  ]);
  const [categories, setCategories] = useState([]);
  const [foodMenus, setFoodMenus] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedFoodMenu, setSelectedFoodMenu] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      axios
        .get(`${apiKey}/api/rms/admin/ingredientCategories`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        })
        .then((response) => {
          const formattedCategories = response.data.map((category) => ({
            value: category.id,
            label: category.category_name,
          }));
          setCategories([
            { value: null, label: languageHelper("Category") },
            ...formattedCategories,
          ]);
        })
        .catch((error) => {
          console.error("Error fetching categories:", error);
        });
    };

    const fetchFoodMenu = () => {
      axios
        .get(`${apiKey}/api/rms/admin/foodMenus`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        })
        .then((response) => {
          const mappedOptions = response.data?.foodMenus?.map((menu) => ({
            value: menu.id,
            label: menu.name,
          }));
          setFoodMenus([
            {
              value: null,
              label: languageHelper("Food Menu"),
            },
            ...mappedOptions,
          ]);
        })
        .catch((error) => {
          console.error("Error fetching food menus:", error);
        });
    };

    fetchCategories();
    fetchFoodMenu();
  }, [user.token]);

  useEffect(() => {
    const fetchInventory = () => {
      axios
        .get(`${apiKey}/api/rms/admin/get-inventory`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          params: {
            outletId: user?.user?.outlet_id,
            categoryId: selectedCategory,
            foodMenuId: selectedFoodMenu,
          },
        })
        .then((response) => {
          setData(response.data.inventory);
          setTotalStockValue(response.data.total_stock_value);
        })
        .catch((error) => {
          console.error("Error fetching inventory:", error);
        });
    };
    fetchInventory();
  }, [selectedCategory, selectedFoodMenu, user.token, user?.user?.outlet_id]);

  return (
    <main>
      <div className="text-d-bg-text text-3xl text-center mb-4 mt-8">
        {languageHelper("Inventory")}
      </div>
      <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>

      <div className="md:flex block flex-wrap gap-5 ms-4 my-2  items-center justify-center">
        <div className="max-w-sm my-2 ">
          <form action="" className="flex items-center">
            <Select
              placeholder={languageHelper("Category")}
              options={categories}
              onChange={(selectedOption) =>
                setSelectedCategory(selectedOption.value)
              }
            />
          </form>
        </div>
        <div className="max-w-sm my-2 ">
          <form action="" className="flex items-center">
            <Select
              placeholder={"Food Menu"}
              options={foodMenus}
              onChange={(selectedOption) =>
                setSelectedFoodMenu(selectedOption.value)
              }
            />
          </form>
        </div>

        {buttonDataa &&
          buttonDataa.map((data, index) => (
            <Link
              className="bg-d-cat-btn text-white text-sm px-3 text-center py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150  w-fit"
              type="button"
              to={data.path}
              key={index}
            >
              {data.buttonText}
            </Link>
          ))}
        <div className="flex gap-2 my-1">
          <p>{languageHelper("Stock Value")}: S.R {totalStockValue.toFixed(2)}</p>
          <svg
            className="fill-d-bg-text	my-1 "
            xmlns="http://www.w3.org/2000/svg"
            height="16"
            width="10"
            viewBox="0 0 320 512"
          >
            <path d="M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z" />
          </svg>
        </div>
      </div>
      {/* 
      {buttonForm &&
          buttonForm.map((data, index) => (
            <Link
              className=" bg-[#7B20C7] text-white text-sm px-3 text-center py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150  w-fit"
              type="button" key={index}>
              {data.buttonText}
            </Link>
          ))} */}
      <DataTable columns={columns} data={data} />
    </main>
  );
}

export default Inventory;
